import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import LabeledField from './labeled-field';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';
import { useSalesOrderIdContext } from '../../../../orders/context/sales-order-id-context-provider';
import style from './order-summary.module.less';

import messages from './messages';

const OrderNumber = () => {
  const intl = useIntl();
  const salesOrderId = useSalesOrderIdContext();
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};
  const { orderNumber, store: { externalUrl } = {} } = salesOrder;

  return (
    <LabeledField label={<FormattedMessage {...messages.orderNumberLabel} />}>
      <div className={style['field-content']}>
        {externalUrl ? (
          <a aria-label={intl.formatMessage(messages.orderNumberAriaLabel)} href={externalUrl} rel='noopener noreferrer' target='_blank'>
            {orderNumber}
            <FontAwesomeIcon className={style['external-link-icon']} icon={faExternalLinkAlt} />
          </a>
        ) : (
          orderNumber
        )}
      </div>
    </LabeledField>
  );
};

export { OrderNumber };
